interface ProductPricingDetails {
   SIP: number
   FD: number
   FT: number
}

export class PricingCalculator {
   static getPriceValue(forOps: boolean, opsPrice, reviewPrice, newPrice) {
      let priceValue = forOps ? opsPrice : reviewPrice
      if (!priceValue && priceValue !== 0) {
         priceValue = newPrice
      }
      return priceValue
   }

   static canFeeHavePriceImpact(fee: any) {
      if (!!fee.linkedProductSKey || !!fee.feeTypeSKey || !fee.considerFeeInImpact) return false

      return true
   }

   static doesFeeHaveOwnPriceImpact(fee: any, forOps: boolean) {
      if (!this.canFeeHavePriceImpact(fee)) return false

      return forOps ? !!fee.opsPrice : !!fee.newPrice
   }

   static doesProductGroupHavePriceImpact(group: any, forOps: boolean) {
      if (forOps) return !!group?.product?.opsPrice || group?.subFeeRows?.some((fee) => PricingCalculator.doesFeeHaveOwnPriceImpact(fee, true))

      return !!group?.product?.newPrice || group?.subFeeRows?.some((fee) => PricingCalculator.doesFeeHaveOwnPriceImpact(fee, false))
   }

   static getFeePriceImpact(product: any, fee: any, forOps: boolean): number {
      if (!PricingCalculator.canFeeHavePriceImpact(fee)) return 0

      const productPriceValue = PricingCalculator.getPriceValue(forOps, product?.opsPrice, product?.newPrice, product?.modelPrice)
      const feePriceValue = PricingCalculator.getPriceValue(forOps, fee.opsPrice, fee.newPrice, fee.modelPrice)

      const { FT } = PricingCalculator.getPricingDetails(product, productPriceValue)
      const feeDifference = feePriceValue - (fee.currentPrice || 0) || 0
      const FR = FT * feeDifference

      // console.log({ FT, FR, feeDifference, feePriceValue, productPriceValue, fee, product });
      return FR
   }

   static getPriceImpact(group: any, forOps: boolean): number {
      const priceValue = PricingCalculator.getPriceValue(forOps, group?.product?.opsPrice, group?.product?.newPrice, group?.product?.modelPrice)

      let RNTP: number
      if (group?.product?.considerDiscountFlag === 1 || group?.product?.considerDiscountFlag == true) {
         RNTP = +(priceValue * (1 - (group?.product?.avgDiscount ?? 0))).toFixed(2)
      } else {
         RNTP = +priceValue.toFixed(2)
      }

      const { FD, FT, SIP } = PricingCalculator.getPricingDetails(group?.product, priceValue)

      let FR = FD * RNTP
      let requestedImpact = FR - group?.product?.l12MRevenue

      if (group?.product?.currentPrice == 0) {
         requestedImpact = 0
      }

      if (group?.product?.considerFeeInImpact === 1 || group?.product?.considerFeeInImpact === true) {
         const feesToAddIn = group?.subFeeRows?.filter((f) => !f.linkedProductSKey && !f.feeTypeSKey)
         let feeIncrease =
            feesToAddIn.reduce((sum, fee) => {
               const feeImpact = PricingCalculator.getFeePriceImpact(group?.product, fee, forOps)
               return sum + (feeImpact || 0)
            }, 0) || 0

         feeIncrease = Math.round(feeIncrease)
         // console.log({ feeIncrease, requestedImpact})
         FR += feeIncrease
         requestedImpact += feeIncrease
      }

      // console.log({ FD, FT, SIP, RNTP, FR, priceValue, forOps, group })
      return Math.round(requestedImpact)
   }

   static getPricingDetails(product, newPrice): ProductPricingDetails {
      const SIP = product?.currentPrice == 0 ? 0 : +((newPrice - product?.currentPrice) / product?.currentPrice).toFixed(3)
      const FD = Math.round(product?.l12MQty * (1 - (product?.elasticity ?? 0) * SIP))
      const FT = Math.round(product?.l12MTransactions * (1 - (product?.elasticity ?? 0) * SIP))

      return {
         SIP,
         FD,
         FT,
      }
   }
}
